import React from 'react';
import styles from './FaqMediaContent.module.scss';
import { HtmlContent } from '../../../Components/HtmlContent/HtmlContent';
import { FaqMedia } from '../../../Models';
import { YouTubeEmbed } from '../../../Components/YouTubeEmbed/YouTubeEmbed';

export interface FaqMediaContentProps {
  media: FaqMedia;
}

export const FaqMediaContent = ({
  media
}: FaqMediaContentProps): React.ReactElement<FaqMediaContentProps> => {
  return (
    <div className={styles.faqMedia}>
      <YouTubeEmbed link={media.link} />

      <div className={styles.title}>{media.title}</div>

      <HtmlContent content={media.description} />
    </div>
  );
};
